/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskOtherRevenueMisc
 */
export interface ExecRiskOtherRevenueMisc {
    /**
     * 
     * @type {string}
     * @memberof ExecRiskOtherRevenueMisc
     */
    Desc?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskOtherRevenueMisc
     */
    BusinessCd?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskOtherRevenueMisc
     */
    TotalRevenueColumnAmt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskOtherRevenueMisc
     */
    RelatedOrExemptFuncIncomeAmt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskOtherRevenueMisc
     */
    UnrelatedBusinessRevenueAmt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskOtherRevenueMisc
     */
    ExclusionAmt?: number;
}

/**
 * Check if a given object implements the ExecRiskOtherRevenueMisc interface.
 */
export function instanceOfExecRiskOtherRevenueMisc(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskOtherRevenueMiscFromJSON(json: any): ExecRiskOtherRevenueMisc {
    return ExecRiskOtherRevenueMiscFromJSONTyped(json, false);
}

export function ExecRiskOtherRevenueMiscFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskOtherRevenueMisc {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'Desc': !exists(json, 'Desc') ? undefined : json['Desc'],
        'BusinessCd': !exists(json, 'BusinessCd') ? undefined : json['BusinessCd'],
        'TotalRevenueColumnAmt': !exists(json, 'TotalRevenueColumnAmt') ? undefined : json['TotalRevenueColumnAmt'],
        'RelatedOrExemptFuncIncomeAmt': !exists(json, 'RelatedOrExemptFuncIncomeAmt') ? undefined : json['RelatedOrExemptFuncIncomeAmt'],
        'UnrelatedBusinessRevenueAmt': !exists(json, 'UnrelatedBusinessRevenueAmt') ? undefined : json['UnrelatedBusinessRevenueAmt'],
        'ExclusionAmt': !exists(json, 'ExclusionAmt') ? undefined : json['ExclusionAmt'],
    };
}

export function ExecRiskOtherRevenueMiscToJSON(value?: ExecRiskOtherRevenueMisc | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Desc': value.Desc,
        'BusinessCd': value.BusinessCd,
        'TotalRevenueColumnAmt': value.TotalRevenueColumnAmt,
        'RelatedOrExemptFuncIncomeAmt': value.RelatedOrExemptFuncIncomeAmt,
        'UnrelatedBusinessRevenueAmt': value.UnrelatedBusinessRevenueAmt,
        'ExclusionAmt': value.ExclusionAmt,
    };
}

